import { combineReducers } from '@reduxjs/toolkit';
import { State } from '../state/state';
import { sessionLogout } from '../actions/session';
import { auth } from '@/data/config/firebase-config';
import storage from 'redux-persist/lib/storage';
import session from './session';
import users from './users';
import global from './global';
import organizations from './organizations';
import sockets from './sockets';
import files from './files';
import roles from './roles';
import permissions from './permissions';
import dashboards from "./dashboards";
import dashboardRows from "./dashboard-rows";
import dashboardSections from "./dashboard-sections";
import dashboardSlots from "./dashboard-slots";
import naeras from "./naeras";

export const appReducer = combineReducers({
  session,
  users,
  global,
  organizations,
  sockets,
  files,
  roles,
  permissions,
  dashboards,
  dashboardRows,
  dashboardSections,
  dashboardSlots,
  naeras,
});

export const rootReducer = (state: State | undefined, action: any) => {
  if (action.type === sessionLogout.type) {
    auth?.signOut();
    storage.removeItem('persist:root');

    return appReducer({} as State, action);
  }

  return appReducer(state, action);
};
